import React, { useEffect, useMemo, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaBullhorn, FaMoneyCheckAlt, FaBuilding, FaPlane, FaPrint, FaPen } from "react-icons/fa";
import { useSelector } from "react-redux";
import { getfinancialyear, getfinYearSingle } from "../CommonUtils/CommonGetApis";
import { CommonAxiosGet } from "../CommonUtils/CommonAxios";
import { Tooltip } from "bootstrap";
import * as XLSX from "xlsx";




import { saveAs } from "file-saver";

const colors = {
    headerBg: "#2d5853", yellow: "#ffd400",
    approved: "#28a745", pending: "#fd7e14", total: "#ffd400",
    balance: "#007bff", budget: "#17a2b8", tableHead: "#e9ecef",
};


export default function BlockWiseExpenditureDashBoard() {
    const rawRoleId = useSelector((state) => state.reducers?.commonmastersreducer?.dualroles);
    const financialyear_gen = useSelector((state) => state.reducers?.commonmastersreducer?.financialyear);
    const logindetails = useSelector((state) => state.reducers?.loginreducer?.userLoginDetials);
    const userId = logindetails?.[0]?.cfms_id;
    const [financialYear, setFinancialYear] = useState("");
    const [reportType, setReportType] = useState("Detailed Head");
    const [cardData, setCardData] = useState({ totalHeads: 0, approvedBills: 0, pendingBills: 0, approvedAmount: 0, pendingAmount: 0, });
    const roleId = Number(rawRoleId);
    const getUnitLabel = (roleId) => {
        if (roleId === 4 || roleId === 2) return "Cr";
        if (roleId === 5 || roleId === 7) return "Lakhs"; if (roleId === 1) return "Rs";
        return "";
    };

    const getDashboardUrl = () => {
        switch (roleId) {
            case 1: return `psCardHeadSubdetailsGet/${roleId}/${userId}/${financialYear}`;
            case 2: return `dpoCardHeadSubdetailsGet/${roleId}/${userId}/${financialYear}`;
            case 4: return `cardHeadSubdetailsGet/${financialYear}`;
            case 5: return `dlpoCardHeadSubdetailsGet/${roleId}/${userId}/${financialYear}`;
            case 7: return `eoCardHeadSubdetailsGet/${roleId}/${userId}/${financialYear}`;
            //  default:return `cardHeadSubdetailsGet/${financialYear}`;
        }
    };

    useEffect(() => { if (financialYear) { loadCardData(); } }, [financialYear]);

    const loadCardData = async () => {
        try {
            const response = await CommonAxiosGet(getDashboardUrl());
            const apiData = response.data.data;



            const card = apiData.cards[0];

            setCardData({
                totalHeads: Number(card.no_of_heads || 0),
                approvedBills: Number(card.approved_bills || 0),
                pendingBills: Number(card.no_of_bills_pending || 0),
                approvedAmount: Number(card.approved_bill_gross_amount || 0),
                pendingAmount: Number(card.bill_gross_pending_amount || 0),
            });

            // Table Data
            setReportData({
                "Detailed Head": apiData.heads || [],
                "Sub Detailed Head": apiData.subDetails || [],
                Items: apiData.hodItemData || [],
            });
        } catch (error) {
            console.log(error);
        }
    };


    const [reportData, setReportData] = useState({
        "Detailed Head": [],
        "Sub Detailed Head": [],
        Items: [],
    });

    const isItems = reportType === "Items";

    const itemsTotals = useMemo(() => {
        const items = reportData.Items || [];
        return items.reduce(
            (acc, row) => {
                acc.approvedBills += Number(row.no_of_bills || 0);
                acc.approvedAmount += Number(row.approved_bill_net_amount || 0);
                acc.pendingBills += Number(row.no_of_bills_pending || 0);
                acc.pendingAmount += Number(row.bill_pending_amount || 0);
                return acc;
            },
            { approvedBills: 0, approvedAmount: 0, pendingBills: 0, pendingAmount: 0 }
        );
    }, [reportData.Items]);

    const displayApprovedBills = isItems ? itemsTotals.approvedBills : cardData.approvedBills;
    const displayPendingBills = isItems ? itemsTotals.pendingBills : cardData.pendingBills;
    const displayApprovedAmount = isItems ? itemsTotals.approvedAmount : cardData.approvedAmount;
    const displayPendingAmount = isItems ? itemsTotals.pendingAmount : cardData.pendingAmount;

      /*  const totalNumber = cardData.approvedBills + cardData.pendingBills;
     const totalAmount = cardData.approvedAmount + cardData.pendingAmount; */

    const totalNumber = displayApprovedBills + displayPendingBills;
    const totalAmount = displayApprovedAmount + displayPendingAmount;


    const totalCount =
        reportType === "Detailed Head"
            ? reportData["Detailed Head"].length
            : reportType === "Sub Detailed Head"
                ? reportData["Sub Detailed Head"].length
                : reportData.Items.length;


    const cards = [
        {
            title: `EXPENDITURE ${reportType.toUpperCase()}`,
            value: totalCount.toLocaleString(),
            number:
                reportType === "Detailed Head"
                    ? "Detailed Heads"
                    : reportType === "Sub Detailed Head"
                        ? "Sub Detailed Heads"
                        : "Items",
            amount: "",
            color: "#6f42c1",
            icon: "📄",
            bg: "#6f42c1",
        },
        /* {
            title: "APPROVED",
            value: cardData.approvedBills.toLocaleString(),
            number: "Number",
            amount: `${cardData.approvedAmount.toFixed(2)}`,
            color: colors.approved,
            icon: "✅",
            bg: "#28a745",
        },
        {
            title: "PENDING",
            value: cardData.pendingBills.toLocaleString(),
            number: "Number",
            amount: `${cardData.pendingAmount.toFixed(2)}`,
            color: colors.pending,
            icon: "⏳",
            bg: "#fd7e14",
        }, */
        {
            title: "APPROVED",
            value: displayApprovedBills.toLocaleString(),
            number: "Number",
            amount: `${displayApprovedAmount.toFixed(2)}`,
            color: colors.approved,
            icon: "✅",
            bg: "#28a745",
        },
        {
            title: "PENDING",
            value: displayPendingBills.toLocaleString(),
            number: "Number",
            amount: `${displayPendingAmount.toFixed(2)}`,
            color: colors.pending,
            icon: "⏳",
            bg: "#fd7e14",
        },
        {
            title: "TOTAL",
            value: Number(totalNumber),
            number: "Number",
            amount: `${Number(totalAmount).toFixed(2)}`,
            color: "#1565c0",
            icon: "📊",
            bg: "#1565c0",
        },
    ];


    /*   const getApprovedBills = (row) =>
        reportType === "Items"
            ? Number(row.no_of_bills || 0)
            : Number(row.no_of_bills || 0); */

    const getApprovedBills = (row) => Number(row.no_of_bills || 0);



    const getApprovedAmount = (row) =>
        reportType === "Items"
            ? Number(row.approved_bill_net_amount || 0)
            : Number(row.bill_gross_amount || 0);


    const getPendingAmount = (row) =>
        Number(row.bill_pending_amount || 0);



    const rows = reportData[reportType] || [];


    // useEffect(() => {
    //     if (!rows.length) {
    //         setCardData({
    //             totalHeads: 0,
    //             approvedBills: 0,
    //             pendingBills: 0,
    //             approvedAmount: 0,
    //             pendingAmount: 0,
    //         });
    //         return;
    //     }

    //     setCardData({
    //         totalHeads: rows.length,

    //         approvedBills: rows.reduce(
    //             (sum, r) =>
    //                 sum +
    //                 Number(
    //                     reportType === "Items"
    //                         ? r.no_of_bills
    //                         : r.approved_bills
    //                 ),
    //             0
    //         ),

    //         pendingBills: rows.reduce(
    //             (sum, r) => sum + Number(r.no_of_bills_pending || 0),
    //             0
    //         ),

    //         approvedAmount: rows.reduce(
    //             (sum, r) =>
    //                 sum +
    //                 Number(
    //                     reportType === "Items"
    //                         ? r.approved_bill_net_amount
    //                         : r.approved_bill_gross_amount
    //                 ),
    //             0
    //         ),

    //         pendingAmount: rows.reduce(
    //             (sum, r) =>
    //                 sum +
    //                 Number(
    //                     reportType === "Items"
    //                         ? r.bill_pending_amount
    //                         : r.bill_gross_pending_amount
    //                 ),
    //             0
    //         ),
    //     });

    // }, [rows, reportType]);



    /* const top5Data = [...rows]
        .sort(
            (a, b) =>
                (Number(b.approved_bill_gross_amount || 0) +
                    Number(b.bill_gross_pending_amount || 0)) -
                (Number(a.approved_bill_gross_amount || 0) +
                    Number(a.bill_gross_pending_amount || 0))
        )
        .slice(0, 5);

    const maxAmount =
        top5Data.length > 0
            ? Math.max(
                ...top5Data.map(
                    (r) =>
                        Number(r.approved_bill_gross_amount || 0) +
                        Number(r.bill_gross_pending_amount || 0)
                )
            )
            : 1; */

    const getTotalAmount = (row) =>
        getApprovedAmount(row) + getPendingAmount(row);

    const top5Data = useMemo(() => {
        return [...rows]
            .sort((a, b) => getTotalAmount(b) - getTotalAmount(a))
            .slice(0, 5);
    }, [rows, reportType]);

    const maxAmount = useMemo(() => {
        return top5Data.length
            ? Math.max(...top5Data.map(getTotalAmount))
            : 1;
    }, [top5Data]);



    const grandTotal = rows.reduce(
        (acc, row) => {
            acc.appBills += getApprovedBills(row);
            acc.appGross += getApprovedAmount(row);

            acc.penBills += Number(row.no_of_bills_pending || 0);
            acc.penGross += getPendingAmount(row);

            acc.appDeduction += Number(row.bill_deduction_amount || 0);
            acc.penDeduction += Number(row.bill_pending_deduction_amount || 0);

            acc.appNet += Number(row.bill_net_amount || 0);
            acc.penNet += Number(row.bill_pending_net_amount || 0);

            return acc;
        },
        {
            appBills: 0,
            appGross: 0,
            appDeduction: 0,
            appNet: 0,
            penBills: 0,
            penGross: 0,
            penDeduction: 0,
            penNet: 0,
        }
    );

    const getName = (row) => {
        switch (reportType) {
            case "Detailed Head":
                return row.detailed_head_name;

            case "Sub Detailed Head":
                return row.subdetailed_head_desc;

            case "Items":
                return row.item_desc;

            default:
                return "";
        }
    };




    const footerColors = {
        reportType: {
            background: "#e2ddfa",
            color: "#000",
        },
        approved: {
            background: "#e8f5e9",
            color: "#2e7d32",
        },
        pending: {
            background: "#fff3e0",
            color: "#ef6c00",
        },
        total: {
            background: "#e3f2fd",
            color: "#0d47a1",
        },
    };

    const grandBills = grandTotal.appBills + grandTotal.penBills;
    const grandGross = grandTotal.appGross + grandTotal.penGross;
    const grandDeduction =
        grandTotal.appDeduction + grandTotal.penDeduction;
    const grandNet = grandTotal.appNet + grandTotal.penNet;

    useEffect(() => {
        getfinancialyear();
    }, []);

    useEffect(() => {
        if (financialyear_gen?.length > 0 && !financialYear) {
            setFinancialYear(financialyear_gen[0].acdyr);
        }
    }, [financialyear_gen]);


    useEffect(() => {
        const tooltipList = [...document.querySelectorAll('[data-bs-toggle="tooltip"]')]
            .map((el) => new Tooltip(el));

        return () => {
            tooltipList.forEach((tooltip) => tooltip.dispose());
        };
    }, [top5Data]);


    const exportToExcel = (tableId, fileName) => {
        const table = document.getElementById(tableId);
        const wb = XLSX.utils.table_to_book(table, {
            sheet: "Report",
            raw: true
        });
        const ws = wb.Sheets["Report"];
        Object.keys(ws).forEach(cell => {
            if (cell[0] === "!") return;
            const v = ws[cell].v;
            if (typeof v === "string" && v.trim().endsWith("%")) {
                ws[cell].t = "s"; ws[cell].v = v.trim();
                ws[cell].w = v.trim(); delete ws[cell].z;
            }
        });
        XLSX.writeFile(wb, `${fileName}.xlsx`);
    };

    const reportName = `${reportType}_Report`;

    return (
        <div style={{ background: "#f8f9fa", minHeight: "80vh", padding: "10px 20px" }}>
            <style>{`
    /* Table Container */
    .table-responsive {
        max-height: 500px;
        overflow: auto;
        border: 1px solid #d6d6d6;
    }

    /* Table */
    .table-custom {
        width: 100%;
        table-layout: fixed;
        border-collapse: separate;
        border-spacing: 0;
        border: 1px solid #d6d6d6;
    }

    /* Cells */
    .table-custom th,
    .table-custom td {
        border: 1px solid #d6d6d6;
        padding: 8px 10px;
        vertical-align: middle;
    }

    /* Sticky Header */
    .table-custom thead th {
        position: sticky;
        top: 0;
        z-index: 30;
        background: #fff;
        font-weight: 600;
    }

    .table-custom thead tr:nth-child(2) th {
        top: 42px;
    }

    /* Sticky First Column */
    .sticky-col {
        position: sticky;
        left: 0;
        z-index: 31;
        background: #fff;

        width: 220px;
        min-width: 220px;
        max-width: 220px;

        white-space: normal;
        word-break: break-word;

        border-right: 1px solid #d6d6d6 !important;
        box-shadow: 1px 0 0 #d6d6d6;
    }

    /* Header First Column */
    .table-custom thead .sticky-col {
        z-index: 35;
    }

    /* Footer */
    .table-custom tfoot td {
        position: sticky;
        bottom: 0;
        z-index: 29;
        background: #fff;
        font-weight: 600;
        border-top: 2px solid #cfcfcf !important;
    }

    /* Footer First Column */
    .table-custom tfoot .sticky-col {
        z-index: 34;
    }

    /* Colors */
    .bg-approved {
        background: #e8f5e9 !important;
        color: #2e7d32;
    }

    .bg-pending {
        background: #fff3e0 !important;
        color: #ef6c00;
    }

    .bg-balance {
        background: #e3f2fd !important;
        color: #1565c0;
    }

    .bg-budget {
        background: #f1f3f4 !important;
        color: #37474f;
    }

    /* Cards */
    .stat-card {
        background: #fff;
        border-radius: 10px;
        padding: 18px;
        border: 1px solid #e5e5e5;
        box-shadow: 0 2px 8px rgba(0,0,0,.08);
        transition: .3s;
    }

    .stat-card:hover {
        transform: translateY(-3px);
        box-shadow: 0 6px 16px rgba(0,0,0,.15);
    }

    .main-header {
        background: ${colors.headerBg};
        color: #fff;
        padding: 15px;
        border-radius: 4px;
        margin-bottom: 5px;
    }
    `}</style>
            {/* Financial Year */}
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "10px",
                    margin: "10px 0 15px 30px",
                }}
            >
                <label
                    style={{
                        fontWeight: "600",
                        color: "#2d5853",
                    }}
                >
                    Select Financial Year:
                </label>

                <select
                    value={financialYear}
                    onChange={(e) => setFinancialYear(e.target.value)}
                    className="form-select"
                    style={{ width: "170px" }}
                >
                    {financialyear_gen?.map((data, i) => (
                        <option key={i} value={data.acdyr}>
                            {data.acdyr}
                        </option>
                    ))}
                </select>
            </div>

            {/* Buttons */}
            <div
                className="d-flex gap-3 mb-4"
                style={{ marginLeft: "30px" }}
            >
                {["Detailed Head", "Sub Detailed Head", "Items"].map((type) => (
                    <button
                        key={type}
                        type="button"
                        onClick={() => setReportType(type)}
                        style={{
                            padding: "7px 24px",
                            borderRadius: "30px",
                            border: `2px solid ${colors.headerBg}`,
                            background:
                                reportType === type ? colors.headerBg : "#fff",
                            color:
                                reportType === type ? "#fff" : colors.headerBg,
                            fontWeight: "600",
                            minWidth: "160px",
                        }}
                    >
                        {type}
                    </button>
                ))}
            </div>

            <div className="row g-3 mb-4">
                {cards.map((c, i) => (
                    <div className="col-lg-3 col-md-6" key={i}>
                        <div className="stat-card">

                            <div className="small fw-bold mb-3" style={{ color: c.color }}>
                                {c.title}
                            </div>

                            <div className="d-flex align-items-center">

                                <div
                                    style={{
                                        width: 56,
                                        height: 56,
                                        borderRadius: "50%",
                                        background: c.bg,
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        marginRight: 15
                                    }}
                                >
                                    {c.icon}
                                </div>

                                <div className="flex-grow-1">

                                    {c.amount ? (
                                        <div
                                            style={{
                                                display: "flex",
                                                justifyContent: "space-around",
                                                alignItems: "center",
                                                width: "100%"
                                            }}
                                        >
                                            <div className="text-center">
                                                <h3 className="fw-bold mb-0">{c.value}</h3>
                                                <span
                                                    className="text-secondary"
                                                    style={{
                                                        fontSize: "15px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    Bills
                                                </span>
                                            </div>

                                            <div
                                                style={{
                                                    width: "1px",
                                                    height: "45px",
                                                    background: "#dee2e6"
                                                }}
                                            ></div>

                                            <div className="text-center">
                                                <h5 className="fw-bold mb-0">{c.amount}</h5>
                                                <span
                                                    className="text-secondary"
                                                    style={{
                                                        fontSize: "15px",
                                                        fontWeight: "600",
                                                    }}
                                                >
                                                    Amount ({getUnitLabel(roleId)})
                                                </span>
                                            </div>
                                        </div>
                                    ) : (
                                        <div style={{ marginLeft: "5px" }}>
                                            <h3 className="fw-bold mb-0">{c.value}</h3>
                                            <span
                                                className="text-secondary"
                                                style={{
                                                    fontSize: "15px",
                                                    fontWeight: "600",
                                                }}
                                            >{c.number} </span>
                                        </div>
                                    )}

                                </div>

                            </div>

                        </div>
                    </div>
                ))}
            </div>
            {/* Table Section */}
            <div className="card shadow-sm border-0 mb-4">
                <div className="card-header bg-white py-3 border-bottom d-flex justify-content-between align-items-center">
                    <h6
                        className="m-0 fw-bold"
                        style={{ color: colors.headerBg }}
                    >
                        EXPENDITURE STATUS BY {reportType.toUpperCase()} WISE
                    </h6>

                    <button
                        className="btn btn-success"
                        onClick={() => exportToExcel("house-tax-table", reportName)}
                    >
                        Export to Excel
                    </button>
                </div>




                <div className="table-responsive">

                    <table id="house-tax-table" className="table table-bordered table-custom mb-0">
                        <thead>
                            <tr>
                                <th
                                    rowSpan="2"
                                    className="sticky-col text-center"
                                    style={{
                                        background: "#e2ddfa",
                                        color: "#000",
                                        fontWeight: "700",
                                        verticalAlign: "middle",
                                    }}
                                >
                                    {reportType}
                                </th>

                                <th colSpan={isItems ? 2 : 4} className="bg-approved">
                                    APPROVED
                                </th>

                                <th colSpan={isItems ? 2 : 4} className="bg-pending">
                                    PENDING
                                </th>

                                <th colSpan={isItems ? 2 : 4}
                                    style={{
                                        background: "#e3f2fd",
                                        color: "#000",
                                        fontWeight: "700",
                                    }}
                                >
                                    TOTAL
                                </th>
                            </tr>
                            <tr>
                                {/* Approved */}
                                <th className="bg-approved">No.of Bills</th>
                                <th className="bg-approved"> {isItems ? "Net Amount" : "Gross Amount"} ({getUnitLabel(roleId)})</th>

                                {!isItems && (
                                    <>
                                        <th className="bg-approved">Deduction Amount ({getUnitLabel(roleId)})</th>
                                        <th className="bg-approved">Net Amount ({getUnitLabel(roleId)})</th>

                                    </>
                                )}

                                {/* Pending */}
                                <th className="bg-pending">No.of Bills</th>
                                <th className="bg-pending"> {isItems ? "Net Amount" : "Gross Amount"} ({getUnitLabel(roleId)})</th>

                                {!isItems && (
                                    <>
                                        <th className="bg-pending">Deduction Amount ({getUnitLabel(roleId)})</th>
                                        <th className="bg-pending">Net Amount ({getUnitLabel(roleId)})</th>

                                    </>
                                )}

                                {/* Total */}
                                <th style={{ background: "#e3f2fd" }}>No.of Bills</th>
                                <th style={{ background: "#e3f2fd" }}> {isItems ? "Net Amount" : "Gross Amount"} ({getUnitLabel(roleId)})</th>

                                {!isItems && (
                                    <>
                                        <th style={{ background: "#e3f2fd" }}>Deduction Amount ({getUnitLabel(roleId)})</th>
                                        <th style={{ background: "#e3f2fd" }}>Net Amount ({getUnitLabel(roleId)})</th>

                                    </>
                                )}
                            </tr>
                        </thead>
                        <tbody>
                            {rows.length > 0 ? (
                                rows.map((row, index) => {
                                    const totalBills =
                                        getApprovedBills(row) +
                                        Number(row.no_of_bills_pending || 0);

                                    const totalGross =
                                        getApprovedAmount(row) +
                                        getPendingAmount(row);

                                    const totalDeduction =
                                        Number(row.bill_deduction_amount || 0) +
                                        Number(row.bill_pending_deduction_amount || 0);

                                    const totalNet =
                                        Number(row.bill_net_amount || 0) +
                                        Number(row.bill_pending_net_amount || 0);

                                    return (
                                        <tr key={index}>
                                            <td className="sticky-col">
                                                {getName(row)}
                                            </td>

                                            <td className="text-end">{getApprovedBills(row)}</td>
                                            <td className="text-end"> {getApprovedAmount(row).toFixed(2)}</td>

                                            {!isItems && (
                                                <>
                                                    <td className="text-end"> {Number(row.bill_deduction_amount).toFixed(2)}</td>
                                                    <td className="text-end"> {Number(row.bill_net_amount).toFixed(2)}</td>
                                                </>
                                            )}

                                            <td className="text-end">{row.no_of_bills_pending}</td>
                                            <td className="text-end"> {getPendingAmount(row).toFixed(2)}</td>

                                            {!isItems && (
                                                <>
                                                    <td className="text-end"> {Number(row.bill_pending_deduction_amount).toFixed(2)}</td>
                                                    <td className="text-end"> {Number(row.bill_pending_net_amount).toFixed(2)}</td>
                                                </>
                                            )}

                                            <td className="text-end">{totalBills}</td>
                                            <td className="text-end">{totalGross.toFixed(2)}</td>

                                            {!isItems && (
                                                <>
                                                    <td className="text-end"> {totalDeduction.toFixed(2)}</td>
                                                    <td className="text-end"> {totalNet.toFixed(2)}</td>
                                                </>
                                            )}
                                        </tr>
                                    );
                                })
                            ) : (
                                <tr>
                                    <td colSpan={isItems ? 7 : 13} className="text-center fw-bold py-4">
                                        No Records Found
                                    </td>
                                </tr>
                            )}
                        </tbody>
                        {rows.length > 0 && (
                            <tfoot>
                                <tr style={{ fontWeight: "bold" }}>
                                    <td
                                        className="sticky-col text-center"
                                        style={{
                                            background: footerColors.reportType.background,
                                            color: footerColors.reportType.color,
                                        }}
                                    >
                                        Grand Total
                                    </td>

                                    {/* Approved */}
                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.approved.background,
                                            color: footerColors.approved.color,
                                        }}
                                    >
                                        {grandTotal.appBills}
                                    </td>

                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.approved.background,
                                            color: footerColors.approved.color,
                                        }}
                                    >
                                        {grandTotal.appGross.toFixed(2)}
                                    </td>

                                    {!isItems && (
                                        <>
                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.approved.background,
                                                    color: footerColors.approved.color,
                                                }}
                                            >
                                                {grandTotal.appDeduction.toFixed(2)}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.approved.background,
                                                    color: footerColors.approved.color,
                                                }}
                                            >
                                                {grandTotal.appNet.toFixed(2)}
                                            </td>
                                        </>
                                    )}

                                    {/* Pending */}
                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.pending.background,
                                            color: footerColors.pending.color,
                                        }}
                                    >
                                        {grandTotal.penBills}
                                    </td>

                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.pending.background,
                                            color: footerColors.pending.color,
                                        }}
                                    >
                                        {grandTotal.penGross.toFixed(2)}
                                    </td>

                                    {!isItems && (
                                        <>
                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.pending.background,
                                                    color: footerColors.pending.color,
                                                }}
                                            >
                                                {grandTotal.penDeduction.toFixed(2)}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.pending.background,
                                                    color: footerColors.pending.color,
                                                }}
                                            >
                                                {grandTotal.penNet.toFixed(2)}
                                            </td>
                                        </>
                                    )}

                                    {/* Total */}
                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.total.background,
                                            color: footerColors.total.color,
                                        }}
                                    >
                                        {grandBills}
                                    </td>

                                    <td
                                        className="text-end"
                                        style={{
                                            background: footerColors.total.background,
                                            color: footerColors.total.color,
                                        }}
                                    >
                                        {grandGross.toFixed(2)}
                                    </td>

                                    {!isItems && (
                                        <>
                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.total.background,
                                                    color: footerColors.total.color,
                                                }}
                                            >
                                                {grandDeduction.toFixed(2)}
                                            </td>

                                            <td
                                                className="text-end"
                                                style={{
                                                    background: footerColors.total.background,
                                                    color: footerColors.total.color,
                                                }}
                                            >
                                                {grandNet.toFixed(2)}
                                            </td>
                                        </>
                                    )}
                                </tr>
                            </tfoot>)}
                    </table>
                </div>
            </div>
            {/* Charts Row */}
            <div className="row g-3 align-items-stretch">
            {[
    {
        label: "Approved",
        color: colors.approved,
        amount: displayApprovedAmount,
    },
    {
        label: "Pending",
        color: colors.pending,
        amount: displayPendingAmount,
    },
    {
        label: "Total",
        color: colors.balance,
        amount: totalAmount,
    },
].map((item, index) => (
    <div className="col-lg-3 col-md-6 d-flex" key={index}>
        <div className="stat-card text-center py-4 h-100 w-100">
            <h6
                className="fw-bold mb-3"
                style={{ color: item.color, fontSize: "16px", textTransform: "uppercase" }}
            >
                {item.label} EXPENDITURE (in {getUnitLabel(roleId)})
            </h6>
            <div
                style={{
                    height: "170px",
                    width: "170px",
                    borderRadius: "50%",
                    border: `15px solid ${item.color}`,
                    margin: "20px auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "12px",
                    overflow: "hidden",
                }}
            >
                <span
                    className="fw-bold"
                    style={{
                        fontSize: "clamp(13px, 1.2vw, 20px)",
                        textAlign: "center",
                        lineHeight: "1.3",
                        wordBreak: "break-word",
                    }}
                >
                    {Number(item.amount).toLocaleString("en-IN", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    })}
                </span>
            </div>
            <div className="d-flex justify-content-center align-items-center mt-2">
                <span
                    style={{
                        width: 14, height: 14, background: item.color,
                        display: "inline-block", borderRadius: "3px", marginRight: "8px",
                    }}
                />
                <span style={{ color: item.color, fontWeight: 600 }}>{item.label}</span>
            </div>
        </div>
    </div>
))}

                {/* 4th card: Top 5 Heads by Total Budget (bar list, not a donut) */}
                {/* Top 5 Card */}
                <div className="col-lg-3 col-md-6 d-flex">
                    <div className="stat-card py-4 px-3 h-100 w-100 d-flex flex-column justify-content-center">
                        <h6
                            className="fw-bold mb-3 text-center"
                            style={{
                                color: "#334155",
                                fontSize: "16px",
                                textTransform: "uppercase",
                            }}
                        >
                            Top 5 {reportType.toUpperCase()} by Total Budget

                            <div
                                style={{
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#475569",
                                    textTransform: "none",
                                    marginTop: "4px",
                                }}
                            >
                                (in {getUnitLabel(roleId)})
                            </div>
                        </h6>

                        {top5Data.length > 0 ? (
                            top5Data.map((r, index) => {
                                /*  const amount =
                                    Number(r.approved_bill_gross_amount || 0) +
                                    Number(r.bill_gross_pending_amount || 0);
*/
                                const amount = getTotalAmount(r);
                                return (
                                    <div
                                        key={`${financialYear}-${reportType}-${index}`}
                                        className="d-flex align-items-center mb-2"
                                    >
                                        <div
                                            style={{
                                                width: 110,
                                                fontSize: 11,
                                                color: "#475569",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap",
                                                cursor: "pointer",
                                            }}
                                            data-bs-toggle="tooltip"
                                            data-bs-placement="top"
                                            data-bs-title={getName(r)}
                                        >
                                            {getName(r)}
                                        </div>

                                        <div
                                            style={{
                                                flex: 1,
                                                background: "#f1f5f9",
                                                borderRadius: 4,
                                                height: 30,
                                            }}
                                        >
                                            <div
                                                style={{
                                                    height: "100%",
                                                    width: `${maxAmount ? (amount / maxAmount) * 100 : 0}%`,
                                                    background: "#0b2158",
                                                    borderRadius: 4,
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "flex-end",
                                                    paddingRight: 6,
                                                    cursor: "pointer",
                                                }}
                                                data-bs-toggle="tooltip"
                                                data-bs-placement="top"
                                                data-bs-title={Number(amount).toLocaleString("en-IN", {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                })}
                                            >
                                                <span
                                                    style={{
                                                        fontSize: 9,
                                                        color: "#fff",
                                                        whiteSpace: "nowrap",
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                    }}
                                                >
                                                    {Number(amount).toLocaleString("en-IN", {
                                                        minimumFractionDigits: 2,
                                                        maximumFractionDigits: 2,
                                                    })}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div className="text-center text-muted mt-4">
                                No Records Found
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
